import { useUpdateUserInfo, useUserInfo } from '@/services/user/hooks';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export type Language = 'en' | 'es';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const { data: userInfo } = useUserInfo();
  const updateUserInfo = useUpdateUserInfo();

  const currentLanguage = i18n.language.split('-')[0] as Language;

  const changeLanguage = useCallback(
    (language: Language) => {
      if (!userInfo?.me?.id) {
        return;
      }

      updateUserInfo.mutate({
        id: userInfo?.me?.id,
        soundsEnabled: userInfo?.me?.soundsEnabled ?? false,
        toThrive: userInfo?.me?.toThrive ?? '',
        language: language || 'en',
        isAllowedFeatureFlag: userInfo?.me?.isAllowedFeatureFlag ?? false,
        areActionsPrivate: userInfo?.me?.areActionsPrivate ?? true,
      });

      i18n.changeLanguage(language);
    },
    [i18n],
  );

  return {
    currentLanguage,
    changeLanguage,
    availableLanguages: ['en', 'es'] as const,
  };
};

export default useLanguage;
